module.exports = __webpack_public_path__ + "img/stock.140b9578.jpg";